import { __extends as I, __spreadArray as c, __assign as v } from "./index11.js";
import { Context as S } from "./index14.js";
import { isBrowser as h } from "./index49.js";
import { PriorityQueue as y } from "./index24.js";
var o = {
  getItem: function() {
  },
  setItem: function() {
  },
  removeItem: function() {
  }
};
try {
  o = h() && window.localStorage ? window.localStorage : o;
} catch (e) {
  console.warn("Unable to access localStorage", e);
}
function g(e) {
  var r = o.getItem(e);
  return (r ? JSON.parse(r) : []).map(function(n) {
    return new S(n.event, n.id);
  });
}
function O(e, r) {
  var n = g(e), i = c(c([], r, !0), n, !0), t = i.reduce(function(a, u) {
    var s;
    return v(v({}, a), (s = {}, s[u.id] = u, s));
  }, {});
  o.setItem(e, JSON.stringify(Object.values(t)));
}
function w(e) {
  var r = o.getItem(e);
  return r ? JSON.parse(r) : {};
}
function _(e, r) {
  var n = w(e);
  o.setItem(e, JSON.stringify(v(v({}, n), r)));
}
function d(e) {
  o.removeItem(e);
}
var q = function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function m(e, r, n) {
  n === void 0 && (n = 0);
  var i = 50, t = "persisted-queue:v1:".concat(e, ":lock"), a = function(l) {
    return (/* @__PURE__ */ new Date()).getTime() > l;
  }, u = o.getItem(t), s = u ? JSON.parse(u) : null, f = s === null || a(s);
  if (f) {
    o.setItem(t, JSON.stringify(q() + i)), r(), o.removeItem(t);
    return;
  }
  !f && n < 3 ? setTimeout(function() {
    m(e, r, n + 1);
  }, i) : console.error("Unable to retrieve lock");
}
var T = (
  /** @class */
  function(e) {
    I(r, e);
    function r(n, i) {
      var t = e.call(this, n, []) || this, a = "persisted-queue:v1:".concat(i, ":items"), u = "persisted-queue:v1:".concat(i, ":seen"), s = [], f = {};
      return m(i, function() {
        try {
          s = g(a), f = w(u), d(a), d(u), t.queue = c(c([], s, !0), t.queue, !0), t.seen = v(v({}, f), t.seen);
        } catch (l) {
          console.error(l);
        }
      }), window.addEventListener("pagehide", function() {
        if (t.todo > 0) {
          var l = c(c([], t.queue, !0), t.future, !0);
          try {
            m(i, function() {
              O(a, l), _(u, t.seen);
            });
          } catch (p) {
            console.error(p);
          }
        }
      }), t;
    }
    return r;
  }(y)
);
export {
  T as PersistedPriorityQueue
};
//# sourceMappingURL=index19.js.map
